import { CalendarIcon } from "lucide-react";

import { Button } from "simplydo/react/ui/button";
import type { ButtonProps } from "simplydo/react/ui/button";
import { Icon } from "simplydo/react/ui/icon";

import { useGetCalendarLink } from "./useGetCalendarLink";

type GetCalendarLinkButtonProps = { calendarId: string } & Omit<
  ButtonProps,
  "onClick" | "children"
>;

const GetCalendarLinkButton = ({
  calendarId,
  ...buttonProps
}: GetCalendarLinkButtonProps) => {
  const getCalendarSyncUrl = useGetCalendarLink(calendarId);

  return (
    <Button
      title="Subscribe in Google Calendar, Apple Calendar, Outlook, or other apps"
      {...buttonProps}
      onClick={getCalendarSyncUrl}
    >
      <Icon icon={CalendarIcon} />
      Get calendar link
    </Button>
  );
};

export default GetCalendarLinkButton;
